import { useState } from 'react';

export default function SessionComposer({ enabled, sending, onSend }) {
  const [text, setText] = useState('');

  if (!enabled) {
    return (
      <div className="cs-composer">
        <div className="cs-hint" style={{ padding: 0 }}>僅 Active／轉接中且為接手客服時可發訊</div>
      </div>
    );
  }

  async function submit(e) {
    e.preventDefault();
    const value = text.trim();
    if (!value || sending) return;
    await onSend(value);
    setText('');
  }

  return (
    <form className="cs-composer" onSubmit={submit}>
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="輸入回覆…"
        disabled={sending}
      />
      <button type="submit" className="btn btn-primary" disabled={sending || !text.trim()}>
        {sending ? '送出中…' : '送出'}
      </button>
    </form>
  );
}
